import { motion } from "framer-motion";
import usePrefersReducedMotion from "./usePrefersReducedMotion";

const spring = { type: "spring", stiffness: 420, damping: 34, mass: 0.7 };

/** Figma "Sidebar item": 44px, Caps/Menu, a 22px pill behind the selected one. */
function desktopBase(isActive) {
  const row = "group relative isolate flex min-h-[44px] w-full items-center gap-space-12 rounded-[22px] px-space-12 py-[10px] text-left text-caps-menu uppercase";
  return isActive ? `${row} text-control-selected-label` : `${row} text-label-primary hover:bg-fill-quaternary`;
}

function mobileBase(isActive, isDark) {
  if (isActive) {
    return isDark
      ? "relative flex-shrink-0 flex items-center gap-1.5 px-2.5 py-2 text-caption-1-semibold text-accent-text bg-white/5 [&>*]:relative [&>*]:z-[1]"
      : "relative flex-shrink-0 flex items-center gap-1.5 px-2.5 py-2 text-caption-1-semibold text-status-success bg-status-success-bg [&>*]:relative [&>*]:z-[1]";
  }
  return "relative flex-shrink-0 flex items-center gap-1.5 px-2.5 py-2 text-caption-1 font-medium text-label-secondary hover:text-label-primary hover:bg-fill-quaternary [&>*]:relative [&>*]:z-[1]";
}

/**
 * Sidebar / mobile nav row with a sliding active pill (layoutId).
 */
export default function MintSpaceNavButton({
  isActive,
  isDark,
  mobile = false,
  onClick,
  onDoubleClick,
  children,
  layoutGroup = "mint-sidebar",
  type = "button",
  className = "",
}) {
  const reduced = usePrefersReducedMotion();
  const base = mobile ? mobileBase(isActive, isDark) : desktopBase(isActive, isDark);
  const pillClass = "absolute inset-0 -z-10 rounded-[22px] bg-control-selected";

  return (
    <button
      type={type}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      className={`${base} ${className}`.trim()}
    >
      {isActive && !mobile && !reduced && (
        <motion.span
          layoutId={`${layoutGroup}-pill`}
          className={pillClass}
          transition={spring}
          initial={false}
          aria-hidden
        />
      )}
      {isActive && !mobile && reduced && <span className={pillClass} aria-hidden />}
      {isActive && mobile && !reduced && (
        <motion.span
          layoutId={`${layoutGroup}-mobile-line`}
          className={`absolute inset-x-2 bottom-0 h-0.5 rounded-full ${
            isDark ? "bg-accent-default" : "bg-emerald-500"
          }`}
          transition={spring}
          initial={false}
          aria-hidden
        />
      )}
      {isActive && mobile && reduced && (
        <span
          className={`absolute inset-x-2 bottom-0 h-0.5 rounded-full ${
            isDark ? "bg-accent-default" : "bg-emerald-500"
          }`}
          aria-hidden
        />
      )}
      {children}
    </button>
  );
}
